import { TransformInt } from '../../../shared';
import { TransformDate } from '../../../shared/decorators/transform-date.decorator';

/**
 * Lease outbox records request DTO
 */
export class LeaseOutboxRecordsRequest {
	leasedBy!: string;
	@TransformDate()
	leasedUntil!: Date;
	@TransformInt()
	batch!: number;
	@TransformInt()
	maxRetryCount!: number;
}
